import { gql } from '@apollo/client';

const fragments = {
  roleItem: gql`
    fragment RoleItem on AuthRole {
      id
      name
      abbreviation
      numUsers
      sourceRole {
        id
      }
    }
  `,
};
export const GET_ROLES = gql`
  query roles {
    roles {
      ...RoleItem
    }
    ${fragments.roleItem}
  }
`;

export const ADD_ROLE = gql`
  mutation addRole($input: AddRoleInput!) {
    addRole(input: $input) {
      role {
        ...RoleItem
      }
      error
    }
    ${fragments.roleItem}
  }
`;

export const UPDATE_ROLE = gql`
  mutation updateRole($input: UpdateRoleInput!) {
    updateRole(input: $input) {
      role {
        ...RoleItem
      }
      error
    }
    ${fragments.roleItem}
  }
`;

export const GET_ROLES_BY_IDS = gql`
  query rolesByIds($roleIds: [ID!]!) {
    rolesByIds(roleIds: $roleIds) {
      id
      permissions {
        id
        permission {
          id
          module {
            id
          }
        }
        scope {
          id
          name
        }
      }
    }
  }
`;

export const DELETE_ROLE = gql`
  mutation deleteRole($id: ID!) {
    deleteRole(id: $id) {
      id
      error
    }
  }
`;

export const UPDATE_PERMISSIONS = gql`
  mutation updateProjectPermissions($inputs: [UpdateProjectPermissionInput!]!) {
    updateProjectPermissions(inputs: $inputs) {
      roles {
        id
        permissions {
          id
          permission {
            id
            module {
              id
            }
          }
          scope {
            id
          }
        }
      }
      error
    }
  }
`;

export const RESTORE_DEFAULT_PERMISSIONS = gql`
  mutation restoreDefaultPermissions($inputs: [ID!]!) {
    restoreDefaultPermissions(inputs: $inputs) {
      error
    }
  }
`;
